import { Data_getInstance2wsdndd6gcuf3 as Data_getInstance } from './adapter/SavePlayerMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SavePlayerMutationSelections_getInstancex0vnrwqe6dn8 as SavePlayerMutationSelections_getInstance } from './selections/SavePlayerMutationSelections.mjs';
import { SavePlayerMutation_VariablesAdapter_instance8tursi8i0zo0 as SavePlayerMutation_VariablesAdapter_instance } from './adapter/SavePlayerMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(savePlayer) {
        this.savePlayer_1 = savePlayer;
      }
      toString() {
        return 'Data(savePlayer=' + this.savePlayer_1 + ')';
      }
      hashCode() {
        return this.savePlayer_1 == null ? 0 : getBooleanHashCode(this.savePlayer_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.savePlayer_1 == other.savePlayer_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ADAPTER_1 = obj(Data_getInstance());
        this.ROOT_FIELD_1 = (new (Builder())('data', Companion_getInstance().type_1)).selections_gjxob8_k$(SavePlayerMutationSelections_getInstance().__root_1).build_1k0s4u_k$();
        this.OPERATION_ID_1 = '5455c8cf2a3b7e1b46acf575b30dd18c607505908c6096cab88915de6fab9630';
        this.OPERATION_NAME_1 = 'savePlayer';
      }
      get_OPERATION_DOCUMENT_t250nw_k$() {
        return 'mutation savePlayer($input: SavePlayerInput!) { savePlayer(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SavePlayerMutationClass;
function SavePlayerMutation() {
  if (SavePlayerMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.input_1 = input;
      }
      operationId_2580de_k$() {
        return '5455c8cf2a3b7e1b46acf575b30dd18c607505908c6096cab88915de6fab9630';
      }
      operationId() {
        return this.operationId_2580de_k$();
      }
      document_e91o2j_k$() {
        return Companion_getInstance_0().get_OPERATION_DOCUMENT_t250nw_k$();
      }
      operationName_1injiq_k$() {
        return 'savePlayer';
      }
      operationName() {
        return this.operationName_1injiq_k$();
      }
      serializeVariables_bugef7_k$(writer, customScalarAdapters, withDefaultValues) {
        SavePlayerMutation_VariablesAdapter_instance.serializeVariables_6d9ki5_k$(writer, this, customScalarAdapters, withDefaultValues);
      }
      adapter_j0zdtd_k$() {
        return Companion_getInstance_0().ADAPTER_1;
      }
      toString() {
        return 'SavePlayerMutation(input=' + this.input_1.toString() + ')';
      }
      hashCode() {
        return this.input_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerMutation()))
          return false;
        if (!this.input_1.equals(other.input_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerMutation', VOID, VOID, [Mutation()]);
    SavePlayerMutationClass = $;
  }
  return SavePlayerMutationClass;
}
//region block: exports
export {
  Data as Data1i1ryxd63q3t,
  SavePlayerMutation as SavePlayerMutation13ci6nh8jmmgu,
};
//endregion

//# sourceMappingURL=SavePlayerMutation.mjs.map
